import { render, staticRenderFns } from "./MoveItemModal.vue?vue&type=template&id=59ae358a&"
import script from "./MoveItemModal.vue?vue&type=script&lang=js&"
export * from "./MoveItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports